var _filter, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShape2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 12,
    viewBox: "0 0 12 12",
    width: 12,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _filter || (_filter = /*#__PURE__*/React.createElement("filter", {
    id: "a",
    filterUnits: "userSpaceOnUse",
    height: 12,
    width: 12,
    x: 0,
    y: 0
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#f14836",
    result: "flood"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceGraphic",
    operator: "in",
    result: "composite"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "SourceGraphic",
    result: "blend"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m6 12a6 6 0 1 1 6-6 6.007 6.007 0 0 1 -6 6zm0-11.451a5.45 5.45 0 1 0 5.451 5.451 5.456 5.456 0 0 0 -5.451-5.451zm.733 8.74h-1.467v-2.557h-2.557v-1.467h2.557v-2.557h1.467v2.557h2.556v1.467h-2.556z",
    fill: "#fff",
    fillRule: "evenodd",
    filter: "url(#a)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShape2);
export default __webpack_public_path__ + "static/media/shape-2.cf63b608a0b143ddb8a744d53ce11a1c.svg";
export { ForwardRef as ReactComponent };